import { Component, Input, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import * as moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ErrorModalComponent } from "../../error-modal/error-modal.component";
import { StorageService } from "../../../services/storage.service";

@Component({
  selector: "app-summary-popup",
  templateUrl: "./summary-popup.component.html",
  styleUrls: ["./summary-popup.component.css"],
})
export class SummaryPopupComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  @Input() selectedList;
  @Input() filter_from;
  @Input() filter_end;
  countvalue: number = 0;
  allVideoDetails: any[] = [];
  getAllVideoDetails: any;
  allVideoDetailsCountvalue: number = 0;
  offset: number = 1;
  total: number;
  p: number;
  pagedItems: any[];
  limit: number = 10;
  pageshow: boolean = true;
  role: any;
  ishod: any;

  constructor(
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
    public globalService: GlobalService,
    private modalService: NgbModal
  ) {
    this.role = this.storageService.getRole();
    this.ishod = this.storageService.getHod();
  }

  ngOnInit() {
    this.getAllVideoDetailsPage();
  }

  async getPage(page: number) {
    this.offset = page;
    await this.getAllVideoDetailsPage();
    const res = await this.serverCall(this.allVideoDetails, page);
    this.total = this.countvalue;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.limit;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  loadMore(index) {
    this.pageshow = true;
    this.offset = index;
    this.getAllVideoDetailsPage();
  }

  previous() {
    this.pageshow = true;
    this.offset = this.offset - 1;
    this.getAllVideoDetailsPage();
  }

  next() {
    this.pageshow = true;
    this.offset = this.offset + 1;
    this.getAllVideoDetailsPage();
  }

  openErrorModal(errMsg,id) {
    if (errMsg) {
      const errorModalComp = this.modalService.open(ErrorModalComponent, {
        scrollable: true,
        size: 'lg'
      });
      errorModalComp.componentInstance.id = id;
      errorModalComp.componentInstance.errMsg = errMsg
        ? errMsg
        : "--No Error Message--";
    }
  }

  async getAllVideoDetailsPage() {
    this.allVideoDetails = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      session_id: this.selectedList.session_id,
      classroom_id: this.selectedList.classroom_id ? this.selectedList.classroom_id:"",
      department_id: this.selectedList.department_id
        ? this.selectedList.department_id : "",
      summary_type: this.selectedList.summary_type,
      professor_id: this.selectedList.professor_id
        ? this.selectedList.professor_id : "",
      camera_start: this.filter_from,
      camera_end: this.filter_end,
      page: this.offset,
      page_size: this.limit,
    };
    this.getAllVideoDetails = await this.globalService.get(
      "classVideoDetail/get-all-video-details",
      filter
    );
    this.allVideoDetails = this.getAllVideoDetails["content"]["rows"];
    this.allVideoDetailsCountvalue = this.getAllVideoDetails["content"].count;
    this.spinner.hide();
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }

  paginationCount(value) {
    this.offset = 1;
    this.limit = value;
    this.getAllVideoDetailsPage();
  }
}
